import { isEmpty } from 'lodash-es';

export const findChanges = (data, compareData) =>
  Object.keys(compareData).reduce((acc, key) => {
    if (Object.hasOwn(data, key) && data[key] !== compareData[key]) {
      return { ...acc, [key]: data[key] };
    }
    return acc;
  }, {});

export const countChanges = (data, compareData) =>
  Object.keys(compareData).reduce((acc, key) => {
    if (Object.hasOwn(data, key) && data[key] !== compareData[key]) {
      return acc + 1;
    }
    return acc;
  }, 0);

export const hasChanges = (data, compareData) =>
  !isEmpty(findChanges(data, compareData));
